// Module-level register for Ops Obligations selection.
// Read by bugReportPayload so triage sees the focused obligation id.

export type OpsObligationFocusSnapshot = {
  obligation_id: string | null;
  kind: string | null;
};

let _focus: OpsObligationFocusSnapshot | null = null;

export function setOpsObligationFocus(focus: OpsObligationFocusSnapshot | null): void {
  _focus = focus;
}

export function clearOpsObligationFocus(): void {
  _focus = null;
}

export function readOpsObligationFocus(): OpsObligationFocusSnapshot | null {
  return _focus;
}

/** Test-only — resets singleton state between runs. */
export function __resetOpsObligationFocusForTests(): void {
  _focus = null;
}
